// extracted by mini-css-extract-plugin
export var productImage = "_m8-1";
export var viewLink = "_m8-2";
export var wishlistItem = "_m8-0";